function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEiffelTower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "90pt",
    height: "90pt",
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 41.039062 61.109375 L 45.089844 42.121094 L 49.050781 61.109375 Z M 13.769531 87.210938 L 27.71875 87.210938 L 32.308594 77.039062 C 40.5 69.300781 49.589844 69.03125 58.320312 77.039062 L 62.910156 87.210938 L 76.230469 87.210938 L 65.878906 66.691406 L 69.300781 66.691406 L 69.300781 61.109375 L 62.910156 61.109375 L 54.988281 41.488281 L 57.78125 41.488281 L 57.78125 35.820312 L 52.828125 35.820312 L 48.421875 11.96875 L 50.671875 11.96875 L 50.671875 6.390625 L 47.789062 6.390625 L 47.339844 2.878906 C 46.621094 2.699219 43.46875 2.699219 42.660156 2.878906 L 42.300781 6.390625 L 39.058594 6.390625 L 39.058594 11.96875 L 41.671875 11.96875 L 37.261719 35.820312 L 31.410156 35.820312 L 31.410156 41.488281 L 35.101562 41.488281 L 27.179688 61.109375 L 20.25 61.109375 L 20.25 66.691406 L 24.121094 66.691406 Z M 13.769531 87.210938 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEiffelTower);
export default __webpack_public_path__ + "static/media/eiffel-tower.47b681719567ca0e3010150bc04793cc.svg";
export { ForwardRef as ReactComponent };